/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const AppNavStepProgress = (props) => {
  if (props.stepTotal <= 1) {
    return null;
  }

  return (
    <div className="cmp-appnav-stepprogress">
      {props.children}
      <div>
        {
          _.times(props.stepTotal).map((i) => {
            const stepClasses = classnames('cmp-appnav-stepprogress-step', {
              'cmp-appnav-stepprogress--current': (i + 1) === props.currentStep,
            });
            return <span key={i} className={stepClasses}>•</span>;
          })
        }
      </div>
    </div>
  );
};
AppNavStepProgress.propTypes = {
  stepTotal: PropTypes.number,
  currentStep: PropTypes.number,
  children: PropTypes.any,
};


export default AppNavStepProgress;
